import Button2 from "../Buttons/Button2";

const Hosting = () => {
  return (
    <div className="flex justify-center bg-transparent mb-20 w-[96.5vw] md:w-[88.5vw] h-[500px] md:h-auto mx-auto">
      <div className=" shadow-slate-400 shadow-md relative rounded-3xl bg-cover">
        <div className="absolute top-[10.765vw] left-[2.526vh] sm:top-[9.765vw] sm:left-[10.526vh]">
        <h1 className="text-black text-[29px] sm:text-[50px] font-semibold">Meet new people</h1>
        <h1 className="text-black text-[29px] sm:text-[50px] font-semibold mb-5 sm:mb-5">Try Hosting</h1>
        <h1 className="text-black text-[16px] sm:text-[24px] font-medium sm:pt-1">Host on our platform for</h1>
        <h1 className="text-black text-[16px] sm:text-[24px] font-medium sm:pb-8 mb-5 sm:mb-0">seamless and hassle free booking</h1>

          <a
            href="https://host.a2zvillaz.com/login/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button2 value="Try Hosting" />
          </a>
        </div>

        <img
          className="object-center rounded-3xl  h-[500px] md:h-auto"
          src="/Hosting-bg.png"
        ></img>
      </div>
    </div>
  );
};

export default Hosting;
